import { FACEBOOK_MESSENGER_SERVICE_NAME, INSTAGRAM_MESSENGER_SERVICE_NAME, WHATSAPP_DISPLAY_NAME } from "./AppConstants";

export const FIELD_MAPPING_SERVICE_PHONE = "phone";
export const FIELD_MAPPING_CONFIGURATION_VARIANT_PHONE = "phone";
export const FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT = "serviceRecipient";

export const FIELD_MAPPING_SERVICE_TABS = [
  {
    key: FIELD_MAPPING_SERVICE_PHONE,
    label: "SMS/" + WHATSAPP_DISPLAY_NAME,
    serviceType: null,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_PHONE,
    mappingTitle: "Phone Number Mapping",
    description:
      "Controls how HelloSend reads phone numbers from your CRM across campaigns, outbound, and inbox.",
    recipientFieldLabel: null,
    recipientFieldPlaceholder: "- Select -",
    notFoundContentText: "No phone field available.",
  },
  {
    key: INSTAGRAM_MESSENGER_SERVICE_NAME,
    label: "Instagram",
    serviceType: INSTAGRAM_MESSENGER_SERVICE_NAME,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT,
    mappingTitle: "Recipient ID Mapping",
    description:
      "Choose where HelloSend stores the Instagram recipient ID inside your CRM. Lookup/related fields are not supported.",
    recipientFieldLabel: "Recipient ID Field",
    recipientFieldPlaceholder: "e.g., IG ID custom field",
    notFoundContentText: "No field available.",
  },
  {
    key: FACEBOOK_MESSENGER_SERVICE_NAME,
    label: "Facebook",
    serviceType: FACEBOOK_MESSENGER_SERVICE_NAME,
    configurationVariant: FIELD_MAPPING_CONFIGURATION_VARIANT_SERVICE_RECIPIENT,
    mappingTitle: "Recipient ID Mapping",
    description:
      "Choose where HelloSend stores the Facebook Messenger recipient ID inside your CRM. Lookup/related fields are not supported.",
    recipientFieldLabel: "Recipient ID Field",
    recipientFieldPlaceholder: "e.g., Messenger PSID custom field",
    notFoundContentText: "No field available.",
  },
];

export const getFieldMappingTabConfig = (serviceTabKey) =>
  FIELD_MAPPING_SERVICE_TABS.find((serviceTab) => serviceTab.key === serviceTabKey);

export const isMessengerFieldMappingService = (serviceType) =>
  Boolean(serviceType && serviceType !== FIELD_MAPPING_SERVICE_PHONE);
